import { styled } from '@mui/material/styles';

const ThumbnailBox = styled('div')({
    position: 'relative',
    width: '100%',
    height: 180,
    overflow: 'hidden',
    borderRadius: '8px 8px 0 0',
    background: '#F3F4F3',
    pointerEvents: 'none',
});

// CSS-scaled sandboxed iframe of the server-compiled HTML snapshot — no server-side
// image generation involved. The iframe is inert (no scripts, no interaction).
const ScaledFrame = styled('iframe')({
    width: 600,
    height: 540,
    border: 0,
    transform: 'scale(0.334)',
    transformOrigin: 'top left',
    position: 'absolute',
    top: 0,
    left: '50%',
    marginLeft: -100,
});

const TemplateThumbnail = ({ html, title }) => (
    <ThumbnailBox>
        <ScaledFrame srcDoc={html || ''} title={title} sandbox="" tabIndex={-1} scrolling="no" />
    </ThumbnailBox>
);

export default TemplateThumbnail;
